<template>
  <v-dialog v-model="dialog" persistent max-width="450px">
    <v-card grid-list-md>
      <ModelTitle title="Create Link" @close="close()" />

      <v-card-text v-if="!created">
        <div class="text-center my-3">
          <span>Enter information to create link</span>
        </div>
        <v-row>
          <v-col cols="12">
            <v-text-field outlined autofocus :hide-details="nameErrors.length === 0" dense :error-messages="nameErrors"
              v-model="FinancialAidApplication.fullName" label="Full Name"></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field outlined autofocus :hide-details="phoneNumberErrors.length === 0" dense :error-messages="phoneNumberErrors"
              v-model="FinancialAidApplication.phoneNumber" v-mask="'(###) ###-####'" label="Phone Number"></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text v-else>
        <v-row>
          <v-col cols="12">
            <v-card dark flat color="text--white">
              <v-card-title>
                <span>Copy This Link To Share</span>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn small @click="copyLink" fab v-on="on">
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                  </template>
                  <span>Copy link</span>
                </v-tooltip>
                <v-tooltip bottom v-if="showShare">
                  <template v-slot:activator="{ on }">
                    <v-btn small @click="shareLink" fab v-on="on">
                      <v-icon>mdi-share</v-icon>
                    </v-btn>
                  </template>
                  <span>Copy link</span>
                </v-tooltip>
              </v-card-title>
              <v-card-text>
                <span style="color: white"> {{ url }} </span>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-col class="shrink">
                  <v-btn dark color="green" @click="sendWhatsAppMessage" small >
                    Send WhatsApp
                  </v-btn>

                </v-col>
                <v-spacer></v-spacer>
                <v-row justify="end">
                  <v-col class="shrink">
                    <v-btn dark color="#F0C316" small @click="sendTextMessage">
                      Send Text Message
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer v-if="created"></v-spacer>
        <v-btn color="secondary" text @click="close()">Close</v-btn>
        <v-spacer v-if="!created"></v-spacer>
        <v-btn v-if="!created" color="primary" :loading="loading" dark @click="submit()">Generate Link</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import applicationService from "../service.js";
import copy from "copy-to-clipboard";
import { mapGetters } from "vuex";

const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");

export default {
  name: "create-FinancialAidApplication",
  props: {
    createDialog: {
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      dialog: false,
      created: false,
      url: null,
      showShare: false,
      FinancialAidApplication: {
        fullName: null,
        phoneNumber: null,
        status: 'created',
      },
    };
  },
  mixins: [validationMixin],
  validations: {
    FinancialAidApplication: {
      fullName: {
        required,
      },
      phoneNumber: {
        required,
      },
    },
  },
  created(){
    if (navigator.share) {
      this.showShare = true;
    } else {
      this.showShare = false;
    }
  },
  watch: {
    createDialog(val) {
      this.dialog = val;
    },
  },
  computed: {
    ...mapGetters("global", ["currentBusiness"]),
    nameErrors() {
      const errors = [];
      if (!this.$v.FinancialAidApplication.fullName.$dirty) return errors;
      if (!this.$v.FinancialAidApplication.fullName.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    },
    phoneNumberErrors() {
      const errors = [];
      if (!this.$v.FinancialAidApplication.phoneNumber.$dirty) return errors;
      if (!this.$v.FinancialAidApplication.phoneNumber.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    },
  },
  methods: {
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.FinancialAidApplication = {
        fullName: null,
        phoneNumber: null,
      };
      this.created = false,
      this.url = null,
      this.$v.$reset();
    },
    shareLink() {
      if (navigator.share) {
        navigator
          .share({
            title: this.currentBusiness.name,
            text: '',
            url: this.url
          })
          .then(() => console.log("Successful share"))
          .catch(error => console.log("Error sharing:", error));
      }
      this.$emit("submit");
      this.close();
    },
    sendTextMessage(){
      const obj = {
        phoneNumber: this.FinancialAidApplication.phoneNumber,
        url: this.url,
        customerName: this.FinancialAidApplication.fullName,
      };
      applicationService
      .publicSendTextMessage(obj)
      .then(() => {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "success",
            title: "Messages Send! ",
          });
      });
      this.$emit("submit");
      this.close();
    },
    sendWhatsAppMessage(){
      let link = `https://api.whatsapp.com/send?phone=${this.FinancialAidApplication.phoneNumber}&text=${this.url}`
      window.open(link, "_blank")
    },
    copyLink() {
      copy(this.url);
      this.$swal
      .mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000
      })
      .fire({
        icon: "success",
        title: "Link is copy!"
      });
      this.$emit("submit");
      this.close();
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        this.loading = true;
        this.FinancialAidApplication.phoneNumber = this.FinancialAidApplication.phoneNumber.replace(
          /[^a-zA-Z0-9]/g,
          ""
        );
        return applicationService
          .create(this.FinancialAidApplication)
          .then((result) => {
            if (result.status) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "success",
                  title: "FinancialAidApplication is created",
                });
              this.loading = false;
              this.url = `${process.env.VUE_APP_FE_URL}/financialAid/${this.currentBusiness.alias}/${result.data.code}`
              this.created = true;
              // this.$emit("submit");
              // this.close();
            }
          })
          .catch((err) => {
            console.log('err', err)
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: err.data.message,
              });
          });
      }
    },
  },
};
</script>

<style scoped></style>
